import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Something went wrong";
};

export async function download(path, params = {}) {
  const r = await api.get(path, { params, responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || "download";
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function uploadFile(file, isPublic = true) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("public", isPublic ? "true" : "false");
  const r = await api.post("/admin/upload", fd);
  return r.data.url;
}
